import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import Typography from '@/components/common/Typography'
import Form from '@/components/common/Form'

const EntryForm = ({ theme, form }) => (
  <Root>
    <Title variant="h3" theme={theme}>エントリーフォーム</Title>
    <Main theme={theme}>
      <Form {...form} scale={500} />
    </Main>
  </Root>
)

const Root = styled.div``

const Title = styled(Typography)`
  text-align: center;
  padding: 40px 16px;
  background-color: ${props => props.theme.scale[500]};
`

const Main = styled.div`
  margin-top: 8px;
`

export default ThemeConsumer(EntryForm)
